import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { generatePalette } from './metricConstatnts';
import { stringIsNullOrEmpty } from '../../util/strings';
import {
    BarController,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Tooltip
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
);
export default withStyles({})(({ loading, variant, colour, label, total, data, options }) => {
    let cssVariant,
        myPalette = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `bar-fill--${variant}`;
    else if (!stringIsNullOrEmpty(colour)) myPalette = generatePalette(data.length, colour);
    return (
        <div className="chart-container">
            {(!!total || 0 === total) && <div className="horizontal-number">{total}</div>}
            <div style={{ width: '100%', minHeight: 300 }}>
                <Chart type="bar" data={data} options={options} />
            </div>
            <div className="label-container">
                <label className="chart-label">{label}</label>
            </div>
        </div>
    );
});
